export enum TaskFlaggedStatus {
  Flag1,
  Flag2
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/user-task/task-flagged-status.ts